import * as _ from 'lodash'
import React from 'react';
import globalRelay from '../globalRelay';
import valueFilters from '../valueFilters';

let luid = 0;
const globalConfig = globalRelay.config!;

export default class AddressEdit extends React.Component<any, any> {
	constructor (props) {
		super(props);

		this.state = {
			idPrefix: 'addressEdit-' + (luid++) + '-',
			regionOptions: [],
			cityOptions: [<option key='city' value="">Select a City</option>]
		};

		_.map(globalConfig.addressing.regions, r => {
			this.state.regionOptions.push(<option key={_.camelCase(r)} value={r} />);
		});

		_.map(globalConfig.addressing.cities, c => {
			this.state.cityOptions.push(<option key={_.camelCase(c)} value={c}>{c}</option>);
		});
	}

	validate (property) {
		if (this.props.disabled || this.props.readOnly) { return true; }
		return this.props.validate(this.props.address, property);
	}

	updateModel (path, autoSave, e) {
		e.preventDefault();
		if (this.props.disabled || this.props.readOnly) { return; }

		const newVal = (autoSave) ? valueFilters.clean(e.target.value) : e.target.value;

		this.props.updateModel(model => {
			model.setAt(path, newVal);
		}, { autoSave: autoSave });
	}

	render () {
		const address = this.props.address;
		const disabled = !!this.props.disabled;

		return (
			<React.Fragment>
				<table className={disabled ? 'half disabled' : 'half'} cellPadding="0" cellSpacing="0">
					<tbody>
						<tr className={!this.validate('street') ? 'required' : ''}>
							<td />
							<td><strong>Address</strong></td>
							<td><input type="text" className="" placeholder="Address" autoCapitalize="" autoCorrect="off" value={address.viewValue('street')} onChange={this.updateModel.bind(this, 'street', false)} onBlur={this.updateModel.bind(this, 'street', true)} /></td>
							<td />
						</tr>
						<tr className={!this.validate('city') ? 'required' : ''}>
							<td />
							<td><strong>City</strong></td>
							<td>
								<input type="text" className="dataList" list={this.state.idPrefix + 'city'} placeholder="Enter or Select a City" value={ address.viewValue('city') } onChange={this.updateModel.bind(this, 'city', false)} onBlur={this.updateModel.bind(this, 'city', true)} />
								<datalist id={this.state.idPrefix + 'city'} >
									{ this.state.cityOptions }
								</datalist>
							</td>

							<td />
						</tr>
					</tbody>
				</table>
				<table className={disabled ? 'half disabled' : 'half'} cellPadding="0" cellSpacing="0">
					<tbody>
						<tr className={!this.validate('region') ? 'required' : ''}>
							<td />
							<td><strong>{ globalConfig.getString('Province') }</strong></td>
							<td>
								<input type="text" className="dataList" list={this.state.idPrefix + 'regions'} placeholder={ `Enter or Select a ${globalConfig.getString('Province')}` } value={address.viewValue('region')} onChange={this.updateModel.bind(this, 'region', false)} onBlur={this.updateModel.bind(this, 'region', true)} />
								<datalist id={this.state.idPrefix + 'regions'}>{ this.state.regionOptions }
								</datalist>
							</td>
							<td />
						</tr>
						<tr className={!this.validate('postalCode') ? 'required' : ''}>
							<td />
							<td><strong>{ globalConfig.getString('Postal Code') }</strong></td>
							<td><input type="text" placeholder={ globalConfig.getString('Postal Code') } autoCapitalize="" autoCorrect="off" value={address.viewValue('postalCode')} onChange={this.updateModel.bind(this, 'postalCode', false)} onBlur={this.updateModel.bind(this, 'postalCode', true)} /></td>
							<td />
						</tr>
					</tbody>
				</table>
			</React.Fragment>
		);
	}
}